module.exports = __webpack_public_path__ + "img/Isolation.46e9afd.svg";